import { render } from "./LayoutForm.vue?vue&type=template&id=3ab57278"
import script from "./LayoutForm.vue?vue&type=script&lang=js"
export * from "./LayoutForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__